import { bg } from "../../../../date-fns/locale/bg.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    bg
  }
};